import { inject, injectable } from 'tsyringe';
import type { ICompanySurveyClient } from 'interfaceAdapter/gatewaySchemas/ICompanySurveyClient';
import type { ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { ICompanySurveyQuery } from 'application/querySchemas/ICompanySurveyQuery';
import type { ISurveyFactory } from 'domain/valueObjects/factories/Survey';
import { ISurvey } from 'domain/entities/Survey/Survey';

@injectable()
export class CompanySurveyQuery implements ICompanySurveyQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanySurveyClient')
        public readonly surveyClient: ICompanySurveyClient,
        @inject('SurveyFactory')
        public readonly factory: ISurveyFactory,
    ) {}

    public async fetch(matchId: number): Promise<ISurvey> {
        const { data, message } = await this.surveyClient.get({
            token: this.companyUserToken.get() || '',
            matchId,
        });

        if (message) {
            throw new Error(message);
        }

        if (!data) throw new Error('アンケート情報の取得に失敗しました');

        return this.factory.buildSurvey(data);
    }
}
